import type { shippingMetafields } from './type.js'

export const isWeightAvailable = (weight: number, method: shippingMetafields) => {
  if (method.weight_high && method.weight_low) {
    return weight >= method.weight_low && weight <= method.weight_high
  } else if (method.weight_high && !method.weight_low) {
    return weight <= method.weight_high
  } else if (method.weight_low && !method.weight_high) {
    return weight >= method.weight_low
  } else {
    return true
  }
}
